import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 justify-center mb-3">
            <i className="ri-fire-line text-accent-500 text-2xl"></i>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热播榜单
            </h2>
          </div>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            实时热度排行，看看大家都在追什么
          </p>
          <div className="space-y-3">
            {rankingData.map((item) => (
              <a
                key={item.rank}
                href={`#rank-${item.rank}`}
                className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer group"
              >
                <div className={`w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-heading text-lg md:text-xl ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-medium text-foreground-950 text-sm md:text-base group-hover:text-primary-600 transition-colors truncate">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap flex-shrink-0">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1.5 text-accent-500 flex-shrink-0">
                  <i className={item.icon}></i>
                  <span className="text-xs md:text-sm font-medium whitespace-nowrap">{item.hot}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}